export default __webpack_public_path__ + "static/media/NgoziEzema.0fb42447.svg";